//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../Weld/Weld.JointmarkBuilder.js";
let d=[[[0,"ShowSolids",1,0],[0,"WeldType",1,0]],[[[],"NewPointsOverride",{R_:{newPointBuilder:"Weld.PointMarkPointBuilder"}},0,0],[["create"],"AppendPointsOverride",{},1,0]],[]];
SPLM.Weld.PointMarkBuilder = class extends SPLM.Weld.JointmarkBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.PointMarkBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.PointMarkBuilder.WeldTypes = Object.freeze({
    "ResistanceSpot" : "ResistanceSpot", "ArcSpot" : "ArcSpot", "Clinch" : "Clinch", "Dollop" : "Dollop", "WeldNut" : "WeldNut", "WeldStud" : "WeldStud", "Custom1" : "Custom1", "Custom2" : "Custom2", "Custom3" : "Custom3", "Custom4" : "Custom4", "Custom5" : "Custom5"});

export default SPLM;